module.exports = __webpack_public_path__ + "img/engineering-pathway.40c48ae5.jpg";